import Fetch from '@/utils/Fetch';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';

const getAllStores = async (search: any, showAll: any, employeeID = null) => {
    let url = `/Store/GetEmployeeStores?employeeID=${employeeID ? employeeID : Storage.getCookie(Enums.Cookie.employeeID)}&searchPhrase=`;
    if (search) {
        url = url + search;
    }
    if (showAll) {
        url = url + "&showAll=true";
    }
    return await Fetch.get({
        url: url
    });
};

const isMultiStore = async (employeeID = null) => {
    const request = await getAllStores(null, true, employeeID);
    return request.TotalResults > 1;
};

const getStores = async (search: any, showAll: any, employeeID = null) => {
    return await getAllStores(search, showAll, employeeID);    
};

const getListOfStores = async () => {
    return await Fetch.get({
        url: '/Store'
    });
}

const getDefaultStore = async () => {
    const stores = await getListOfStores();
    return stores?.Results?.find((x: any) => x.IsDefault) ?? null;
}

export default {
    isMultiStore,
    getStores,
    getListOfStores,
    getDefaultStore
};
